import { render } from "./HelpUpdateMaterialRoute.vue?vue&type=template&id=627af651"
import script from "./HelpUpdateMaterialRoute.vue?vue&type=script&lang=js"
export * from "./HelpUpdateMaterialRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__